import React from 'react';

export default function LoadingBlock() {
  return (
    <span className="animate-pulse block hover:bg-gray-50">
      <div className="px-4 py-4 sm:px-6">
        <div className="flex items-center justify-between">
          <div className="h-4 bg-gray-300 rounded w-full"></div>
        </div>
      </div>
    </span>
  );
}
